/* eslint-disable comma-dangle */
const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');
const blockIconURI = require('./baidubrain-logo.svg');
const menuIconURI = blockIconURI;

const languageNames = require('scratch-translate-extension-languages');
const nets = require('nets');

const Resampler = require('./resampler.js');
// const RenderedTarget = require('../../sprites/rendered-target');

const BUFSIZE = 8192;

const recognizeMap = {
    'ingredient': '/api/baiduaips/classifyIngredient',
    'plant': '/api/baiduaips/classifyPlant',
    'dish': '/api/baiduaips/classifyDish',
    'animal': '/api/baiduaips/classifyAnimal',
    'redwine': '/api/baiduaips/classifyRedwine',
    'flower': 'https://aip.baidubce.com/rest/2.0/image-classify/v1/flower',
    'car': '/api/baiduaips/classifyCar',
    'landmark': '/api/baiduaips/classifyLandmark'
}

const wordTMap = {
    'currency': '/api/baiduaips/ocrGeneralBasic',
    'handwriting': '/api/baiduaips/ocrHandwriting',
    'licensePlate': '/api/baiduaips/ocrLicensePlate'
}

function formatData (data) {
    const result = Object.entries(data).map(([key, value]) => `${key}=${value}`).join('&');
    return result;
}

const sexType = {
    'male': '男性',
    'female': '女性'
}
const expressionType = {
    'none': '不笑',
    'smile': '微笑',
    'laugh': '大笑'
}
const shapeType = {
    'square': '正方形',
    'triangle': '三角形',
    'oval': '椭圆',
    'heart': '心形',
    'round': '圆形',
}

const baidu_aip_error_map = {
    ocr_error_code: {
        1: '未知错误，请再次请求，如果持续出现此类错误，请在控制台提交工单联系技术支持团队', // Unknown error	
        2: '服务暂不可用，请再次请求，如果持续出现此类错误，请在控制台提交工单联系技术支持团队', // Service temporarily unavailable	
        3: '调用的API不存在，请检查请求URL后重新尝试，一般为URL中有非英文字符，如"-"，可手动输入重试', // Unsupported openapi method	
        4: '集群超限额，请再次请求，如果持续出现此类错误，请在控制台提交工单联系技术支持团队', // Open api request limit reached	
        6: '无接口调用权限，创建应用时未勾选相关文字识别接口，请登录百度云控制台，找到对应的应用，编辑应用，勾选上相关接口后重新调用', // No permission to access data
        14: 'IAM鉴权失败，建议用户参照文档自查生成sign的方式是否正确，或换用控制台中ak sk的方式调用', // IAM Certification failed	
        17: '免费测试资源使用完毕，每天请求量超限额，已支持计费的接口，您可以在控制台文字识别服务选择购买相关接口的次数包或开通按量后付费；邀测和未支持计费的接口，您可以在控制台提交工单申请提升限额', // Open api daily request limit reached	
        18: 'QPS超限额，免费额度并发限制为2QPS，开通按量后付费或购买次数包后并发限制为10QPS，如您需要更多的并发量，可以选择购买QPS叠加包；邀测和未支持计费的接口，您可以在控制台提交工单申请提升限额', // Open api qps request limit reached	
        19: '请求总量超限额，已支持计费的接口，您可以在控制台文字识别服务选择购买相关接口的次数包或开通按量后付费；邀测和未支持计费的接口，您可以在控制台提交工单申请提升限额', // Open api total request limit reached	
        100: '无效的access_token参数，token拉取失败，您可以参考“Access Token获取”文档重新获取', // Invalid parameter	
        110: 'access_token无效，token有效期为30天，请注意需要定期更换，也可以每次请求都拉取新token', // Access token invalid or no longer valid
        111: 'access token过期，token有效期为30天，请注意需要定期更换，也可以每次请求都拉取新token', // Access token expired
        216100: '请求中包含非法参数，请检查后重新尝试', // invalid param
        216101: '缺少必须的参数，请检查参数是否有遗漏', // not enough param	
        216102: '请求了不支持的服务，请检查调用的url', // service not support
        216103: '请求中某些参数过长，请检查后重新尝试', // param too long	
        216110: 'appid不存在，请重新核对信息是否为后台应用列表中的appid', // appid not exist
        216200: '图片为空，请检查后重新尝试', // empty image
        216201: '上传的图片格式错误，现阶段我们支持的图片格式为：PNG、JPG、JPEG、BMP，请进行转码或更换图片', // image format error
        216202: '上传的图片大小错误，现阶段我们支持的图片大小为：base64编码后小于4M，分辨率不高于4096x4096，请重新上传图片', // image size error
        216202: '上传的包体积过大，现阶段不支持 10M 或以上的数据包', // input oversize
        216630: '识别错误，请再次请求，请确保图片中包含对应卡证票据', // recognize error
        216631: '识别银行卡错误，出现此问题的原因一般为：您上传的图片非银行卡正面，上传了异形卡的图片、上传的银行卡正面图片不完整或模糊', // recognize bank card error
        216633: '识别身份证错误，出现此问题的原因一般为：您上传了非身份证图片、上传的身份证图片不完整或模糊', // recognize idcard error
        216634: '检测错误，请再次请求，如果持续出现此类错误，请在控制台提交工单联系技术支持团队', // detect error
        282000:	'服务器内部错误，如果您使用的是高精度接口，报这个错误码的原因可能是您上传的图片中文字过多，识别超时导致的，建议您对图片进行切割后再识别，其他情况请再次请求， 如果持续出现此类错误，请在控制台提交工单联系技术支持团队', // internal error
        282003: '请求参数缺失', // missing parameters: {参数名}
        282005: '处理批量任务时发生部分或全部错误，请根据具体错误码排查', // batch processing error
        282006: '批量任务处理数量超出限制，请将任务数量减少到10或10以下', // batch task limit reached
        282100: '图片压缩转码错误', // image transcode error
        282102: '未检测到图片中识别目标，请确保图片中包含对应卡证票据，出现此问题的原因一般为：您上传了非卡证图片、图片不完整或模糊', // target detect error
        282103: '图片目标识别错误，请确保图片中包含对应卡证票据，出现此问题的原因一般为：您上传了非卡证图片、图片不完整或模糊', // target recognize error
        282110: 'URL参数不存在，请核对URL后再次提交', // urls not exit
        282111: 'URL格式非法，请检查url格式是否符合相应接口的入参要求', // url format illegal
        282112: 'url下载超时，请检查url对应的图床/图片无法下载或链路状况不好，或图片大小大于3M，或图片存在防盗链，您可以重新尝试以下，如果多次尝试后仍不行，建议更换图片地址', // url download timeout
        282113: 'URL返回无效参数', // url response invalid
        282114: 'URL长度超过1024字节或为0', // url size error
        282134: '增值税发票验真接口，国税局端网络超时（一般因地方税务局升级或系统调整造成，建议您第2日重试，如果持续出现此类错误，请在控制台提交工单联系技术支持团队）', // officialWeb service exception
        282808: 'request id 不存在', // request id: xxxxx not exist
        282809: '返回结果请求错误（不属于excel或json）', // result type error
        282810: '图像识别错误，请再次请求，如果持续出现此类错误，请在控制台提交工单联系技术支持团队', // image recognize error
    },
    
    speech_recognize_error_code: {
        3300: '输入参数不正确', // 用户输入错误 请仔细核对文档及参照 demo，核对输入参数
        3301: '音频质量过差', // 用户输入错误 请上传清晰的音频
        3302: '鉴权失败', // 用户输入错误 token 字段校验失败，请用 appkey 和 app secret 生成。 或者 6: No permission to access data（app无此接口权限，到控制台添加）。 或者并发超限。 或者自训练平台 lm_id 不属于该账号
        3303: '百度服务器后端繁忙', // 服务端问题 有可能是原始音频质量过差。可以请将 api 返回结果和原始音频反馈至论坛或者 QQ 群
        3304: '用户的请求并发超限', // 用户请求超限 请降低识别 api 请求频率 （并发以 appId 计算，移动端如果共用则累计）
        3305: '用户的日 pv（日请求量）超限', // 用户请求超限, 请开通付费，购买调用量资源（账号内所有应用 APPID 共用调用量限额）
        3307: '语音服务器后端识别出错问题', // 服务端问题 有可能是原始音频质量过差。可以将 api 返回结果和原始音频反馈至工单、论坛或者 QQ 群
        3308: '音频过长', // 用户输入错误 音频时长不超过 60s，请将音频时长截取为 60s 以下，特别是 amr 格式
        3309: '音频数据问题', // 用户输入错误 服务端无法将音频转为 pcm 格式，可能是长度问题，音频格式问题等。 请将输入的音频时长截取为 60s 以下，并核对下音频的编码，采样率 16000，单声道，小端序，16bits。
        3310: '输入的音频文件过大 或 len 参数过大', // 用户输入错误 文件内容过大，音频时长不能超过 60s
        3311: '采样率 rate 参数不在选项里', // 用户输入错误 目前 rate 参数支持 16000、8000，填写其他值即会有此错误。
        3312: '音频格式 format 参数不在选项里', // 用户输入错误 目前格式仅仅支持 pcm，wav 或 amr，如填写 mp3 即会有此错误
        3313: '语音服务器解析超时', // 服务端问题 请将 api 返回结果反馈至工单、论坛或者 QQ 群
        3314: '音频长度过短', // 用户输入错误 用户的 len 参数小于等于 4
        3315: '语音服务器处理超时', // 服务端问题 请将 api 返回结果反馈至工单、论坛或者 QQ 群
        3316: '音频转为 pcm 失败', // 用户输入错误 使用 pcm 格式，或者确认 wav 和 amr 的采样率 16000，单声道。 wav 是否是 pcm 编码，小端序，16bits
    },
    tts_error_code: {
        500: '不支持输入', // 请求超时 1. 确认是否设置请求超时；2. 网络是否正常 如果设置超时时间，可以设置更长，切换网络好的环境
        501: '输入参数不正确', // 输出参数错误或类型不对 检查输入参数，以及参数类型 根据参数类型正确填写参数
        502: 'token验证失败', // 鉴权信息过期，鉴权额度用尽 1. 重新请求；2. 确认控制台应用额度，主要需区分普通发音人、精品发音人、臻品发音人 开通对应接口的额度
        503: '合成后端错误', // 合成文本中包含非gbk编码 文本是否是gbk编码 1. 替换文本；2. 如仍无法解决，向百度侧提供包含sn的报错信息，以及请求的时间戳
        6: '无权限', // "No permission to access data" 对控制台内app进行编辑，添加语音合成权限
        13: 'QPS超限', // "Open api qps request limit reached" 降低QPS用量或在控制台内购买QPS扩容
        15: '并发超限', // "Open api concurrency limit reached" 降低并发用量或在控制台内购买QPS扩容
        16: '字数超限', // "Open api characters limit reached" 检查对应接口额度,区分普通发音人和精品发音人
        18: '集群并发超限', // "Open api cluster limit reached" 联系百度工作人员
        336200: '内部错误', // internal error 创建、查询
        336201: '未知task id', // unknown task id 查询
        336202: '无效参数值', // invalid param: task_ids 创建、查询
        336203: '缺少必要参数', // missing param: 'param_name' 创建、查询	
        336204: '请开通付费，购买调用字符数资源', // Open api total request limit reached 创建、查询
        336212: '请求数据为非法json', // invalid json 创建、查询
        336213: '缺少必要header', // missing header: 'header_name' 创建、查询
        100000:	'内部错误', // Inner error
        100001:	'不支持的音频格式', // Format is not supported
        100002:	'获取文本内容失败', // Failed to query texts from uri
        100003:	'上传音频文件失败', // Failed to upload results to BOS
        100010:	'合成音频服务失败', // Inner error: TTS failed
        100020:	'鉴权流控不通过，请检查额度', // Authentication and Rate Limit Failed
        100022:	'HTTP网络交互失败', // A http exception occurred during Authentication and Rate Limitation
    },
    
    nlp_error_code: {

        1: '服务器内部错误，请再次请求', // Unknown error 如果持续出现此类错误，请通过QQ群（458967388）或工单联系技术支持团队解决
        2: '服务暂不可用，请再次请求', // Service temporarily unavailable 如果持续出现此类错误，请通过QQ群（458967388）或工单联系技术支持团队解决
        3: '调用的API不存在，请检查接口地址是否输入正确', // Unsupported openapi method
        4: '集群超限额', // Open api request limit reached 请通过QQ群（458967388）或工单联系技术支持团队
        6: '无权限访问', // No permission to access data 请检查创建的APP应用是否有该接口的使用权限（1、API列表页是否可见、2、应用详情的接口是否勾选）
        17: '每天请求量超限额', // Open api daily request limit reached 请您严格控制日调用量，调用量需<=该接口的日调用量限制，若有更高调用量需求，请前往产品页面进行购买或通过QQ群（458967388）进行咨询
        18: 'QPS超限额', // Open api qps request limit reached 请您严格控制处理并发量，调用并发需<=该接口的QPS限制，若有更高QPS需求，请前往产品页面进行购买或通过QQ群（458967388）进行咨询
        19: '请求总量超限额', // Open api total request limit reached
        100: '输入中包含了无效或错误参数，请检查代码', // Invalid parameter
        110: 'Access Token失效，请进行更换', // Access token invalid or no longer valid
        111: 'Access token过期', // Access token expired Access Token的有效期为30天，请在到期前进行更换
        216202: '传入文本涉及敏感内容，请检查后重试', // data size error
        216203: '传入参数非法，请检查后重试', // input data cannot handle
        216401: '请求频率超限', // internal error	
        282000: '服务器内部错误，请再次请求', // internal error 如果持续出现此类错误，请通过QQ群（458967388）或工单联系技术支持团队
        282002: '编码错误', // input encoding error 接口默认支持的是GBK编码，若需要输入的文本为UTF-8编码，请在url上添加参数charset=UTF-8
        282004: '请求中包含非法参数，请检查后重新尝试', // invalid parameter(s)
        282008: '仅支持GBK和UTF-8，其余为不支持的字符编码，请检查后重新尝试', // unsupported charset:{字符编码名称}
        282011: '定制化接口未使用数据进行训练，或者训练后未生效该接口，建议检查定制化是否完成数据训练以及是否已生效该接口', // API not customized
        282130: '当前查询无结果返回，请检查原始评论中是否含有核心观点，也可能是机器召回不足导致观点无法被识别到导致', // no result 如需优化，请工单反馈
        282131: '输入长度超限', // input text too long 请参照接口文档说明，检查输入文本的长度，并进行严格控制
        282133: '接口参数缺失', // param {参数名} not exist 请检查输入参数是否有遗漏，补充参数并再次尝试
        282134: '输入为空，请检查输入内容，输入的内容避免为空', // input empty
        282300: '算法词典暂未收录该word', // word error 可联系客服做算法版本的升级以进行支持，相关badcase和需求可以提交工单进行咨询
        282301: 'word_1提交的词汇暂未收录，无法比对相似度', // word_1 error 可联系客服做算法版本升级进行支持，相关badcase和需求可以提交工单进行咨询
        282302: 'word_2提交的词汇暂未收录，无法比对相似度', // word_2 error 可联系客服做算法版本升级进行支持，相关badcase和需求可以提交工单进行咨询
        282303: 'word_1和word_2暂未收录，无法比对相似度', // word_1&word_2 error 可联系客服做算法版本升级进行支持，相关badcase和需求可以提交工单进行咨询
        282355: '达到存储数量上限', // storage space full 请检查已经创建的实体库或实体名单数量
        282501: '单个实体的字符串长度超限，请控制长度限制为64个字符内', // input text length invalid
        // 2: '后端连接超时', // 重试
        52000: '成功', // 无
        52001: '请求超时', // 重试
        52002: '系统错误', // 重试
        52003: '未授权用户', // 检查您的appid是否正确
        52004: '输入解析失败', // 检查输入编码格式，有无特殊字符，是否是json格式
        52005: '输入字段有误', // 是否包含text字段
        52006: '输入文本长度有误', // 输入不能超过5个字符
        52007: '输入文本包含政治&黄色内容', // 换输入文本
        52008: '后台服务返回错误', // 重试
        54003: '访问频率受限', // 请降低您的调用频率
        54100: '查询接口参数为空', // 检查是否少传参数
        54102: '无写诗结果', // 重试
    },
    
    image_error_code: {
        1: '服务器内部错误，请再次请求', // Unknown error 如果持续出现此类错误，请提交工单联系技术支持团队
        2: '服务暂不可用，请再次请求', // Service temporarily unavailable 如果持续出现此类错误，请提交工单联系技术支持团队
        3: '调用的API不存在，请检查请求URL后重新尝试', // Unsupported openapi method 一般为URL中有非英文字符，如“-”，可手动输入重试
        4: '集群超限额，请再次请求', // Open api request limit reached 如果持续出现此类错误，请提交工单联系技术支持团队
        6: '无权限访问该用户数据，创建应用时未勾选相关接口', // No permission to access data 请登录百度云控制台，找到对应的应用，编辑应用，勾选上相关接口，然后重试调用
        13: '获取token失败', // Get service token failed
        14: 'IAM鉴权失败', // IAM Certification failed 建议用户参照文档自查鉴权方式是否正确，或换用控制台中ak sk的方式调用
        15: '应用不存在或者创建失败', // app not exsits or create failed
        17: '每天请求量超限额', // Open api daily request limit reached 已上线计费的接口，请直接在控制台开通计费，调用量不受限制，按调用量阶梯计费；未上线计费的接口，请提交工单联系申请提额
        18: 'QPS超限额', // Open api qps request limit reached 已上线计费的接口，请直接在控制台开通计费，调用量不受限制，按调用量阶梯计费；未上线计费的接口，请提交工单联系申请提额
        19: '请求总量超限额', // Open api total request limit reached 已上线计费的接口，请直接在控制台开通计费，调用量不受限制，按调用量阶梯计费；未上线计费的接口，请提交工单联系申请提额
        100: '无效的access_token参数', // Invalid parameter token拉取失败，可以参考“Access Token获取”重新获取
        110: 'access_token无效', // Access token invalid or no longer valid token有效期为30天，注意需要定期更换，也可以每次请求都拉取新token
        111: 'access_token无效', // Access token expired token有效期为30天，注意需要定期更换，也可以每次请求都拉取新token
        216100: '请求中包含非法参数，请检查后重新尝试', // invalid param
        216101: '缺少必须的参数，请检查参数是否有遗漏', // not enough param
        216102: '请求了不支持的服务', // service not support 请检查调用的url
        216103: '请求中某些参数过长', // param too long 请检查后重新尝试
        216110: 'appid不存在，请重新核对信息是否为后台应用列表中的appid', // appid not exist
        216200: '图片为空，请检查后重新尝试', // empty image
        216201: '上传的图片格式错误', // image format error 现阶段我们支持的图片格式为：PNG、JPG、JPEG、BMP，请进行转码或更换图片
        216202: '上传的图片大小错误', // image size error 现阶段我们支持的图片大小为：base64编码后小于4M，分辨率不高于4096*4096，请重新上传图片
        216203: '自定义菜品识别服务错误码：上传的图片中包含多个主体，请上传只包含一个主体的菜品图片入库', // dish feature not single
        216203: 'logo识别服务错误码：后端服务超时', // meta rpc timeout 请工单联系技术支持团队
        216401: '服务器内部错误', // internal error 请再次请求，如果持续出现此类错误，请提交工单联系技术支持团队。
        216630: '识别错误', // recognize error 请再次请求，如果持续出现此类错误，请提交工单联系技术支持团队
        216634: '检测错误', // detect error 请再次请求，如果持续出现此类错误，请提交工单联系技术支持团队
        216681: '添加入库的图片已经在库里，完全相同（Base64编码相同）的图片不能重复入库', // item has existed	
        282000: '服务器内部错误', // internal error 请再次请求，如果持续出现此类错误，请提交工单联系技术支持团队
        282003: '请求参数缺失', // missing parameters: {参数名}
        282004: '请求参数错误', // invalid parameter(s) 请参考API说明文档，修改参数后重试
        282005: '处理批量任务时发生部分或全部错误', // batch  processing error 请根据具体错误码排查
        282006: '批量任务处理数量超出限制，请将任务数量减少到10或10以下', // batch task  limit reached
        282100: '图片压缩转码错误', // image transcode error
        282101: '长图片切分数量超限', // image split limit reached
        282102: '未检测到图片中识别目标', // target detect error
        282103: '图片目标识别错误', // target recognize error
        282110: 'URL参数不存在，请核对URL后再次提交', // urls not exit
        282111: 'URL格式非法，请检查url格式是否符合相应接口的入参要求', // url format illegal
        282112: 'url下载超时，请检查url对应的图床/图片无法下载或链路状况不好，您可以重新尝试一下，如果多次尝试后仍不行，建议更换图片地址', // url download timeout
        282113: 'URL返回无效参数', // url response invalid
        282114: 'URL长度超过1024字节或为0', // url size error
        282808: 'request id 不存在', // request id: xxxxx not exist
        282809: '返回结果请求错误（不属于excel或json）', // result type error
        282810: '图像识别错误', // image recognize error
        283300: '入参格式有误，可检查下图片编码、代码格式是否有误', // Invalid argument
        336000: '服务器内部错误', // Internal error 请再次请求， 如果持续出现此类错误，请提交工单联系技术支持团队
        336001: '入参格式有误，比如缺少必要参数、图片base64编码错误等等，可检查下图片编码、代码格式是否有误', // Invalid Argument 有疑问请提交工单联系技术支持团队
    },
    
    face_error_code: {
        2: '服务暂不可用', // Service temporarily unavailable 可直接提交工单，咨询问题类型请选择人工智能服务；
        4: '集群超限额', // Open api request limit reached 可直接提交工单，咨询问题类型请选择人工智能服务；
        6: '没有接口权限', // no permission to access data 请确认您调用的接口已经被赋权 常见问题是有V3版本权限，调用的是v2版本接口； 需要企业认证的，开通企业认证后一个小时左右即可使用。
        17: '每天流量超限额', // Open api daily request limit reached 可提交工单，咨询问题类型请选择人工智能服务；
        18: 'QPS超限额', // Open api qps request limit reached 可直接自助购买更多QPS、联系商务接口人、或者提交工单，咨询问题类型请选择人工智能服务；
        19: '请求总量超限额', // Open api total request limit reached 可提交工单，咨询问题类型请选择人工智能服务；
        100: '无效的access_token参数', // Invalid parameter token拉取失败，可以参考“Access Token获取”重新获取
        110: 'Access Token失效', // Access token invalid or no longer valid token有效期为30天，注意需要定期更换，也可以每次请求都拉取新token
        111: 'Access token过期', // Access token expired token有效期为30天，注意需要定期更换，也可以每次请求都拉取新token
        222001: '必要参数未传入', // param[fieldName] is null 参考API说明文档，传入必须的fieldName字段
        222002: '参数格式错误', // param[start] format error 参考API说明文档，修改参数
        222003: '参数格式错误', // param[length] format error 参考API说明文档，修改参数
        222004: '参数格式错误', // param[op_app_id_list] format error 参考API说明文档，修改参数
        222005: '参数格式错误', // param[group_id_list] format error 参考API说明文档，修改参数
        222006: '参数格式错误', // group_id format error 参考API说明文档，修改参数
        222007: '参数格式错误', // uid format error 参考API说明文档，修改参数
        222008: '参数格式错误', // face_id format error 参考API说明文档，修改参数
        222009: '参数格式错误', // quality_conf format error 参考API说明文档，修改参数
        222010: '参数格式错误', // user_info format error 参考API说明文档，修改参数
        222011: '参数格式错误', // param[uid_list] format error 参考API说明文档，修改参数
        222012: '参数格式错误', // param[op_app_id] format error 参考API说明文档，修改参数
        222013: '参数格式错误', // param[image] format error 参考API说明文档，修改参数
        222014: '参数格式错误', // param[app_id] format error 参考API说明文档，修改参数
        222015: '参数格式错误', // param[image_type] format error 参考API说明文档，修改参数
        222016: '参数格式错误', // param[max_face_num] format error 参考API说明文档，修改参数
        222017: '参数格式错误', // param[face_field] format error 参考API说明文档，修改参数
        222018: '参数格式错误', // param[user_id] format error 参考API说明文档，修改参数
        222019: '参数格式错误', // param[quality_control] format error 参考API说明文档，修改参数
        222020: '参数格式错误', // param[liveness_control] format error 参考API说明文档，修改参数
        222021: '参数格式错误', // param[max_user_num] format error 参考API说明文档，修改参数
        222022: '身份证号不符合要求', // param[id_card_number] format error 备注：中国大陆身份证号的每一位数字都有其生成规则，不可随意填写。	填写正确的身份证号
        222023: '参数格式错误', // param[name] format error 请检查手机号、姓名、身份证号格式是否正确
        222024: '参数格式错误', // param[face_type] format error 参考API说明文档，修改参数
        222025: '参数格式错误', // param[face_token] format error 参考API说明文档，修改参数
        222026: '参数格式错误', // param[max_star_num] format error 参考API说明文档，修改参数
        222027: '验证码长度错误', // code length param error (最小值大于最大值)	参考API说明文档，修改参数
        222028: '参数格式错误', // param[min_code_length] format error 参考API说明文档，修改参数
        222029: '参数格式错误', // param[max_code_length] format error 参考API说明文档，修改参数
        222030: '参数格式错误', // param[match_threshold] format error 参考API说明文档，修改参数
        222039: '参数格式错误', // param[face_sort_type] format error 参考API说明文档，修改参数
        222200: '该接口需使用 application/json 的格式进行请求', // request body should be json format 请修改接口格式为：application/json
        222201: '服务端请求失败', // network not available 重新尝试
        222202: '图片中没有人脸', // pic not has face 检查图片质量
        222203: '无法解析人脸', // image check fail 检查图片质量
        222204: '从图片的url下载图片失败', // image_url_download_fail 请确认url可公网访问
        222205: '服务端请求失败', // network not availablel 重新尝试
        222206: '服务端请求失败', // rtse service return fail 重新尝试
        222207: '未找到匹配的用户', // match user is not found 请确认人脸库中 是否存在此用户
        222208: '图片的数量错误', // the number of image is incorrect 多张图片请使用 json格式传输
        222209: 'face token不存在', // face token not exist 请确认您操作的人脸已创建成功；若face_token未注册到 人脸库则有效期只有1小时 注册人脸库的 face_token永久有效
        222210: '人脸库中用户下的人脸数目超过限制', // the number of user's faces is beyond the limit 当前每个用户下限制人脸数目最大20张
        222213: '人脸尺寸过小，请保证人脸区域在64*64以上', // face size is too small 请重新尝试，请重新上传符合人脸尺寸要求的图片
        222214: '请使用非卡通的人脸图像', // face are cartoon images 请重新尝试，请重新上传非卡通的人脸图像
        222215: '人脸属性编辑处理该图像失败，请使用其他图片', // face quality is not acceptable 请使用其他图片重新上传
        222300: '人脸图片添加失败', // add face fail 重新尝试
        222301: '获取人脸图片失败', // get face fail 请重新尝试，如果持续出现此类错误，请提交工单
        222302: '服务端请求失败', // system error 重新尝试
        222303: '获取人脸图片失败', // get face fail 请重新尝试，如果持续出现此类错误，请提交工单
        222309: '图片尺寸过小，请使用清晰的图片', // image size is too small 请重新尝试，请重新上传符合尺寸要求的图片
        222152: '人脸属性编辑，target参数错误', // param[target] format error 请修改参数后重试
        222514: '人脸属性编辑v2调用服务失败，请重试', // face editattrpro operation fail 请重试
        223100: '操作的用户组不存在', // group is not exist 请确认您操作的用户组已创建成功
        223101: '该用户组已存在', // group is already exist 请不要重复创建用户组
        223102: '该用户已存在', // user is already exist 请不要重复创建用户
        223103: '找不到该用户', // user is not exist 请确认您操作的用户已创建成功
        223104: 'group_list包含组数量过多', // group_list is too large 请按照文档提示设置group_list参数
        223105: '该人脸已存在', // face is already exist 请不要重复添加人脸
        223106: '该人脸不存在', // face is not exist 请确认您操作的人脸已创建成功；若face_token未注册到人脸库则有效期只有1小时，注册人脸库的face_token永久有效
        223107: '人脸库中人脸复制时源组与目标组的scene_type不同', // scene_type not same scene_type不同的组之间用户不能复制
        223110: 'uid_list包含数量过多', // uid_list is too large 请按照文档提示设置user_list参数
        223111: '目标用户组不存在', // dst group not exist 请确认您操作的用户组已创建成功
        223112: 'quality_conf格式不正确', // quality_conf format error 请按照文档提示设置quality_conf参数
        223113: '人脸有被遮挡', // face is covered 提示用户请勿遮挡面部
        223114: '人脸模糊', // face is fuzzy 人脸图片模糊，前端页面可以提示用户拍摄时不要晃动手机
        223115: '人脸光照不好', // face light is not good 提示用户到光线适宜的地方拍摄
        223116: '人脸不完整', // incomplete face 提示用户请勿遮挡面部
        223117: 'app_list包含app数量过多', // app_list is too large 请按照文档提示设置app_list参数
        223118: '质量控制项错误', // quality control error 请按照文档提示设置质量控制参数
        223119: '活体控制项错误', // liveness control item error 请按照文档提示设置活体控制参数
        223120: '活体检测未通过', // liveness check fail 此次活体检测结果为非活体
        223121: '质量检测未通过 左眼遮挡程度过高', // left eye is occlusion 提示用户请勿遮挡左眼
        223122: '质量检测未通过 右眼遮挡程度过高', // right eye is occlusion 提示用户请勿遮挡右眼
        223123: '质量检测未通过 左脸遮挡程度过高', // left cheek is occlusion 提示用户请勿遮挡左脸颊
        223124: '质量检测未通过 右脸遮挡程度过高', // right cheek is occlusion 提示用户请勿遮挡右脸颊
        223125: '质量检测未通过 下巴遮挡程度过高', // chin contour is occlusion 提示用户请勿遮挡下巴
        223126: '质量检测未通过 鼻子遮挡程度过高', // nose is occlusion 提示用户请勿遮挡鼻子
        223127: '质量检测未通过 嘴巴遮挡程度过高', // mouth is occlusion 提示用户请勿遮挡嘴巴
        222901: '参数校验初始化失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222902: '参数校验初始化失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222903: '参数校验初始化失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222904: '参数校验初始化失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222905: '接口初始化失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222906: '接口初始化失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222907: '缓存处理失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222908: '缓存处理失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222909: '缓存处理失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222910: '数据存储处理失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222911: '数据存储处理失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222912: '数据存储处理失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222913: '接口初始化失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222914: '接口初始化失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222915: '后端服务连接失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222916: '后端服务连接失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222304: '图片尺寸太大', // image size is too large 请确保图片尺寸在1920x1080以下
        222305: '当前版本不支持图片存储', // pic storage not support 请确认face_token的使用符合规范
        223128: '正在清理该用户组的数据', // group was deleting 请等该用户组清理完毕后再对该组进行操作
        223136: '该组内存在关联图片，无法新建相同名称组', // images exist in this group 需清理完该组下的数据后才能创建组
        222361: '公安服务连接失败', // system busy 请重新尝试，若尝试多次无效，请提交工单咨询
        222046: '参数格式错误', // param[template_type] format error 请参考接口文档修改
        222101: '参数格式错误', // param[merge_degree] format error 请参考API说明文档，修改参数
        222102: '参数格式错误', // param[face_location] format error 参考API说明文档，修改参数
        222307: '图片非法 鉴黄未通过', // image illegal, reason: porn 请重新上传合法的图片
        222308: '图片非法 含有政治敏感人物', // image illegal, reason: sensitive person 请重新上传合法的图片
        222211: '人脸融合失败 模板图质量不合格', // template image quality reject 请检查模板图是否符合人脸融合文档中的质量要求
        222212: '人脸融合失败', // merge face fail 请更换素材后重新尝试，如果持续出现此类错误，请提交工单
        223129: '人脸未面向正前方（人脸的角度信息大于30度）', // face not forward 请使用面向正前方的人脸图片
        223130: 'spoofing_control参数格式错误', // spoofing_control item error 请求参数spoofing_control的值不是接口文档指定的[‘NONE’, ‘LOW’, ‘NORMAL’, ‘HIGH’] 其中之一，修改请求参数 spoofing_control 值
        223131: '合成图检测未通过', // spoofing check fail 此次活体检测结果为合成图攻击
        223133: '视频提取图片活体检测失败', // video extract image liveness check fail 视频可能存在活体攻击
        223052: '视频中的动作验证未通过', // action identify fail 请重新录制视频
        223201: '请求参数scene_type 格式错误', // param[scene_type] format error 请检查请求参数
        223202: '识别时请求的scene_type与group设置的scene_type不匹配', // scene_type does not match 检查请求参数 （此校验默认不开启）
    }
}

/**
 * How long to wait in ms before timing out requests to translate server.
 * @type {int}
 */
const serverTimeoutMs = 10000; // 10 seconds (chosen arbitrarily).

let springFestivalCouplets_stamp = new Date().getTime()
let poems_stamp = new Date().getTime()

class BaiduBrainBlocks {
    constructor (runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        this.runtime = runtime;
        this._context = null;
        this.initvocie = this.initvocie.bind(this);
        this.recognize = this.recognize.bind(this);
        this.processAudioCallback = this.processAudioCallback.bind(this);
        this.recognizeSuccess = this.recognizeSuccess.bind(this);
        this.resetListening = this.resetListening.bind(this);
        this.runtime.on('PROJECT_STOP_ALL', this.resetListening.bind(this));
        this._onSpeechFail = null;

        this.renderer = this.runtime.renderer;//识别类别

        this.recognizeResult

        this.initvocie();
        //tts人物
        this.ttsCharactersPer = '1';
        //
        this.characterResults



        this.getAccessToken = () => {
            let _search = location.search;
            location._query = {};
            location._query['lang'] = 'en';
            let queryArray = [];
            if (_search) {
                _search = _search.replace('?', '');
                queryArray = _search.split('&');
                for (let i = 0; i < queryArray.length; i++) {
                    location._query[queryArray[i].split('=')[0]] = queryArray[i].split('=')[1];
                }
            }
            let accessToken = location._query['accessToken'];
            let domain = location._query['domain'] || 'https://coursedev.e-ai-edu.com';
            return {
                accessToken,
                domain
            }
        };
        this.domain = this.getAccessToken().domain;

        this.baidu_access_token = '';//
        this.newAccessToken();

        //人脸检测
        this.faceAgeResult;
        this.faceSexResult;
        this.faceShapeResult;
        this.faceExpressionResult;
        this.beautyResult;

        this.faceDetectedResult = false;

        //人脸搜索
        this.searchResultNames;
        this.searchScore;

        //百度翻译
        this._viewerLanguageCode = this.getViewerLanguageCode();

        this._randomLanguageCode = 'en';

        this._supportedLanguages = [];

        this._translateResult = '';

        this._lastLangTranslated = '';

        this._lastTextTranslated = '';

    }

    /**
     * The key to load & store a target's test-related state.
     * @type {string}
     */
    static get STATE_KEY () {
        return 'Scratch.BaiduBrain';
    }

    initvocie () {
        if (!this._context) {
            this._context = new (window.AudioContext || window.webkitAudioContext)();
            this._resampler = new Resampler(this._context.sampleRate, 16000, 1, BUFSIZE);
        }
        this._audioPromise = navigator.mediaDevices.getUserMedia({
            audio: true
        });

        this._audioPromise.then(stream => {
            this._micStream = stream;
        }).catch(e => {
            console.log(`Problem connecting to microphone:  ${e}`);
        });

    }
    newAccessToken () {
        fetch(`${this.domain}/api/baiduaips/getAipToken?access_token=${this.getAccessToken().accessToken}`, {
            method: 'GET',
        })
            .then((response) => response.json())
            .then((responseJsonData) => {
                if (responseJsonData.error) {
                    throw responseJsonData;
                    // return responseJsonData
                }
                // console.log('responseJsonData ', responseJsonData);
                this.baidu_access_token = responseJsonData && responseJsonData.access_token
            })
            .catch((error) => {
                console.error('error ', error);
                if (error.error) {
                    alert(error.error.message);
                } else {
                    alert(error);
                }
            });
    }
    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo () {

        this._supportedLanguages = this._getSupportedLanguages(this.getViewerLanguageCode());
        // this._randomLanguageCode = this._supportedLanguages[
        //     Math.floor(Math.random() * this._supportedLanguages.length)].value;
        this._randomLanguageCode = "en"
        return {
            // 详细介绍：https://github.com/LLK/scratch-vm/blob/develop/docs/extensions.md
            // Required: the machine-readable name of this extension.
            // Will be used as the extension's namespace.
            id: 'BaiduBrain',
            name: '百度大脑',
            // Optional: URI for an icon to be displayed in the blocks category menu.
            menuIconURI: menuIconURI,
            // Optional: URI for a block icon, to display at the edge of each block for this
            blockIconURI: blockIconURI,
            // Optional: Link to documentation content for this extension.
            // If not present, offer no link.
            // docsURI: 'https://....',
            // 插件右上角的硬件连接状态显示按钮
            showStatusButton: false,
            blocks: [
                // {
                //     opcode: 'vocieTimeout',
                //     blockType: BlockType.COMMAND,
                //     text: formatMessage({
                //         id: 'BaiduBrain.vocieTimeout',
                //         default: '听候语音输入超时 [vocieTimeout]',
                //         description: 'vocieTimeout'
                //     }),
                //     arguments: {
                //         vocieTimeout: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '0'
                //         }
                //     }
                // },
                {
                    opcode: 'vocieTimeout',
                    blockType: BlockType.COMMAND,
                    text: '听候语音输入超时 [TIMEOUT]',
                    arguments: {
                        TIMEOUT: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 6
                        }
                    },
                },
                {
                    opcode: 'BaiduAI_hear',
                    blockType: BlockType.HAT,
                    // text: formatMessage({
                    //     id: 'BaiduBrain.hear',
                    //     default: '当听到 [hear]',
                    //     description: 'hear'
                    // }),
                    text: '当听到 [hear]',
                    isEdgeActivated: false,
                    arguments: {
                        hear: {
                            type: ArgumentType.STRING,
                            defaultValue: '你好'
                        }
                    }
                },
                {
                    opcode: 'voiceInput',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.voiceInput',
                        default: '语音输入',
                        description: 'voiceInput',
                    }),
                },
                '---',
                {
                    opcode: 'ttsCharacters',
                    blockType: BlockType.COMMAND, // BlockType COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.ttsCharacters',
                        default: 'tts人物 [ttsCharacters]',
                        description: 'ttsCharacters'
                    }),
                    arguments: {
                        ttsCharacters: {
                            type: ArgumentType.STRING,
                            menu: 'characters',
                            defaultValue: '1'
                        }
                    }
                },
                {
                    opcode: 'textToSpeech',
                    blockType: BlockType.COMMAND, // BlockType COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.textToSpeech',
                        default: 'tts文字转语音 [textToSpeech]',
                        description: 'textToSpeech'
                    }),
                    arguments: {
                        textToSpeech: {
                            type: ArgumentType.STRING,
                            defaultValue: '你好'
                        }
                    }
                },
                '---',
                {
                    opcode: 'springFestivalCouplets',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.springFestivalCouplets',
                        default: '写春联 [springFestivalCouplets]',
                        description: 'springFestivalCouplets',
                    }),
                    arguments: {
                        springFestivalCouplets: {
                            type: ArgumentType.STRING,
                            defaultValue: '人工智能',
                        }
                    }
                },
                {
                    opcode: "poems",
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: "BaiduBrain.poems",
                        default: "写诗 [poems]",
                        description: "poems",
                    }),
                    arguments: {
                        poems: {
                            type: ArgumentType.STRING,
                            defaultValue: '爱熊',
                        }
                    }
                },
                '---',
                {
                    opcode: 'identifyCategories',
                    blockType: BlockType.COMMAND, // BlockType COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.identifyCategories',
                        default: '识别类别 [identifyCategories]',
                        description: 'identifyCategories'
                    }),
                    arguments: {
                        identifyCategories: {
                            type: ArgumentType.STRING,
                            menu: 'categories',
                            defaultValue: 'ingredient'
                        }
                    }
                },
                {
                    opcode: 'identityComplete',
                    blockType: BlockType.HAT,
                    isEdgeActivated: false,
                    text: '当识别完成',
                    // text: formatMessage({
                    //     id: 'BaiduBrain.identityComplete',
                    //     default: '当识别完成',
                    //     description: 'identityComplete'
                    // }),
                },
                {
                    opcode: 'identityResults',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.identityResults',
                        default: '识别结果',
                        description: 'identityResults',
                    }),
                },
                '---',
                {
                    opcode: 'characterType',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.characterType',
                        default: '文字识别类型 [textType] 数组 [textArr]',
                        description: 'characterType',
                    }),
                    arguments: {
                        textType: {
                            type: ArgumentType.STRING,
                            menu: 'textType',
                            defaultValue: 'currency',
                        },
                        textArr: {
                            type: ArgumentType.STRING,
                            defaultValue: ' ',
                        },
                    },
                },
                //人脸检测
                '---',
                {
                    opcode: 'faceMarker',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.faceMarker',
                        default: '人脸检测',
                        description: 'faceMarker',
                    }),

                },
                {
                    opcode: 'faceDetected',
                    blockType: BlockType.HAT,
                    isEdgeActivated: false,
                    text: '当检测到人脸',
                },
                {
                    opcode: 'faceAge',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.faceAge',
                        default: '年龄',
                        description: 'faceAge',
                    }),
                },
                {
                    opcode: 'faceGender',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.faceGender',
                        default: '性别',
                        description: 'faceGender',
                    }),
                },
                {
                    opcode: 'faceAppearance',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.faceAppearance',
                        default: '颜值',
                        description: 'faceAppearance',
                    }),
                },
                {
                    opcode: 'faceExpression',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.faceExpression',
                        default: '表情',
                        description: 'faceExpression',
                    }),
                },
                {
                    opcode: 'faceShape',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.faceShape',
                        default: '脸型',
                        description: 'faceShape',
                    }),
                },
                {
                    opcode: 'gender',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'BaiduBrain.gender',
                        default: '性别[gender]',
                        description: 'gender',
                    }),
                    arguments: {
                        gender: {
                            type: ArgumentType.STRING,
                            menu: 'genderType',
                            defaultValue: 'male',
                        },
                    },
                },
                {
                    opcode: 'expression',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'BaiduBrain.expression',
                        default: '表情[expression]',
                        description: 'expression',
                    }),
                    arguments: {
                        expression: {
                            type: ArgumentType.STRING,
                            menu: 'expressionType',
                            defaultValue: 'none',
                        },
                    },
                },
                {
                    opcode: 'feature',
                    blockType: BlockType.BOOLEAN,
                    text: formatMessage({
                        id: 'BaiduBrain.feature',
                        default: '脸型[feature]',
                        description: 'feature',
                    }),
                    arguments: {
                        feature: {
                            type: ArgumentType.STRING,
                            menu: 'featureType',
                            defaultValue: 'square',
                        },
                    },
                },
                '---',
                //人脸添加
                {
                    opcode: 'faceGroupCreate',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.faceGroup',
                        default: '创建人脸 组 [faceGroupArr]',
                        description: 'faceGroup',
                    }),
                    arguments: {
                        faceGroupArr: {
                            type: ArgumentType.STRING,
                            defaultValue: 'GroupA',
                        },
                    },
                },
                {
                    opcode: 'faceGroupAdd',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.faceGroupAdd',
                        default: '添加人脸 [faceAddName] 组 [faceArr]',
                        description: 'faceGroupAdd',
                    }),
                    arguments: {
                        faceAddName: {
                            type: ArgumentType.STRING,
                            defaultValue: '',
                        },
                        faceArr: {
                            type: ArgumentType.STRING,
                            defaultValue: 'GroupA',
                        },
                    },
                },
                //人脸搜索
                {
                    opcode: 'faceGroupSearch',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.faceGroupSearch',
                        default: '搜索人脸 组 [faceGroupSearchArr]',
                        description: 'faceGroupSearch',
                    }),
                    arguments: {
                        faceGroupSearchArr: {
                            type: ArgumentType.STRING,
                            defaultValue: 'GroupA',
                        },
                    },
                },
                {
                    opcode: 'faceGroupSearchLevel',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: formatMessage({
                        id: 'BaiduBrain.faceGroupSearchLevel',
                        default: '搜索人脸 组 [faceSearchArr] 可信度 [reliability]',
                        description: 'faceGroupSearchLevel',
                    }),
                    arguments: {
                        faceSearchArr: {
                            type: ArgumentType.STRING,
                            defaultValue: 'GroupA',
                        },
                        reliability: {
                            type: ArgumentType.STRING,
                            defaultValue: '80',
                        },
                    },
                },
                {
                    opcode: 'BaiduAI_face_search',
                    blockType: BlockType.HAT,
                    // text: formatMessage({
                    //     id: 'BaiduBrain.hear',
                    //     default: '当听到 [hear]',
                    //     description: 'hear'
                    // }),
                    text: '当搜索到名字 [searchName]',
                    isEdgeActivated: false,
                    arguments: {
                        searchName: {
                            type: ArgumentType.STRING,
                            defaultValue: ''
                        }
                    }
                },
                {
                    opcode: 'searchDone',
                    blockType: BlockType.HAT,
                    text: '当搜索完成',
                    isEdgeActivated: false,
                },
                {
                    opcode: 'searchResultName',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.searchResultName',
                        default: '搜索结果名字',
                        description: 'searchResultName',
                    }),
                },
                {
                    opcode: 'searchReliability',
                    blockType: BlockType.REPORTER,
                    text: formatMessage({
                        id: 'BaiduBrain.searchReliability',
                        default: '搜索可信度',
                        description: 'searchReliability',
                    }),
                },
                '---',
                //百度翻译
                {
                    opcode: 'getTranslate',
                    text: formatMessage({
                        id: 'BaiduBrain.getTranslate',
                        default: '将 [WORDS] 译为 [LANGUAGE]',
                        description: 'translate some text to a different language'
                    }),
                    blockType: BlockType.REPORTER,
                    arguments: {
                        WORDS: {
                            type: ArgumentType.STRING,
                            defaultValue: formatMessage({
                                id: 'BaiduBrain.defaultTextToTranslate',
                                default: '你好',
                                description: 'hello: the default text to translate'
                            })
                        },
                        LANGUAGE: {
                            type: ArgumentType.STRING,
                            menu: 'languages',
                            defaultValue: this._randomLanguageCode
                        }
                    }
                },
                {
                    opcode: 'getViewerLanguage',
                    text: formatMessage({
                        id: 'BaiduBrain.viewerLanguage',
                        default: '访客语言',
                        description: 'the languge of the project viewer'
                    }),
                    blockType: BlockType.REPORTER,
                    arguments: {}
                },
                // 正则表达式
                {
                    opcode: 'replace_to',
                    blockType: BlockType.REPORTER, // BOOLEAN, COMMAND
                    text: '将 [replace_origin] 中的 [replace_from] 替换为 [replace_to]',
                    arguments: {
                        replace_origin: {
                            type: ArgumentType.STRING,
                            defaultValue: '',
                        },
                        replace_from: {
                            type: ArgumentType.STRING,
                            defaultValue: '',
                        },
                        replace_to: {
                            type: ArgumentType.STRING,
                            defaultValue: '',
                        },
                    },
                },
            ],
            menus: {
                characters: [
                    { text: '度小宇', value: '1' },
                    { text: '度小美', value: '0' },
                    { text: '度逍遥', value: '3' },
                    { text: '度丫丫', value: '4' },
                ],
                categories: [
                    { text: '蔬菜', value: 'ingredient' },
                    { text: '盆栽', value: 'plant' },
                    { text: '菜品', value: 'dish' },
                    { text: '动物', value: 'animal' },
                    { text: '红酒', value: 'redwine' },
                    // { text: "花", value: "flower" },
                    { text: '汽车', value: 'car' },
                    { text: '地标', value: 'landmark' },
                ],

                textType: [
                    { text: '通用', value: 'currency' },
                    { text: '手写', value: 'handwriting' },
                    { text: '车牌', value: 'licensePlate' },
                ],
                facemarker: [
                    { text: '不标记', value: '1' },
                    { text: '标记', value: '2' },
                ],
                genderType: [
                    { text: '男性', value: 'male' },
                    { text: '女性', value: 'female' },
                ],
                expressionType: [
                    { text: '不笑', value: 'none' },
                    { text: '微笑', value: 'smile' },
                    { text: '大笑', value: 'laugh' },
                ],
                featureType: [
                    { text: '正方形', value: 'square' },
                    { text: '三角形', value: 'triangle' },
                    { text: '椭圆', value: 'oval' },
                    { text: '心形', value: 'heart' },
                    { text: '圆形', value: 'round' },
                ],

                languages: {
                    acceptReporters: true,
                    items: this._supportedLanguages
                }
            }

        }
    }
    /**
     * TODO 这个是摘取过来的，作用还没有彻底搞明白。
     * Retrieve the block primitives implemented by this package. 
     * @return {object.<string, Function>} Mapping of opcode to Function.
    */
    recognize () {
        const token = this.getAccessToken().accessToken;
        const _recognizeSuccess = this.recognizeSuccess;
        const _onSpeechFail = this._onSpeechFail;
        this.resetListening();
        const dataLength = this.bufferArray.length * 2; // 16bit
        const buffer = new ArrayBuffer(dataLength);
        const data = new DataView(buffer);
        let offset = 0;

        for (let i = 0; i < this.bufferArray.length; i++, offset += 2) {
            let s = Math.max(-1, Math.min(1, this.bufferArray[i]));
            data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
        }
        const blob = new Blob([data], { type: 'audio/wav' });
        const formData = new FormData();
        formData.append('file', blob);
        fetch(`${this.domain}/api/baiduaips/aipspeechRecognize?access_token=${token}`, {
            body: formData,
            method: 'POST'
        }).then(res => res.json()).then(ret => {
            console.log(ret);
            if (ret.err_no === 0) {
                _recognizeSuccess(ret.result[0].substr(0, ret.result[0].length - 1));
                // _recognizeSuccess(ret.result[0]);
            } else if (_onSpeechFail) {
                if (baidu_aip_error_map.speech_recognize_error_code[ret.err_no]) {
                    _onSpeechFail(baidu_aip_error_map.speech_recognize_error_code[ret.err_no]);
                } else {
                    _onSpeechFail(ret.err_msg);
                }
                
            }
        });
    }
    processAudioCallback (e) {
        let resampled = this._resampler.resample(e.inputBuffer.getChannelData(0))
        this.bufferArray.push.apply(this.bufferArray, resampled);
    }
    recognizeSuccess (txt) {

        this.result = txt;
        console.log('recognizeSuccess', this.result)
        if (this._onSpeechDone) {
            this._onSpeechDone();
        }
        const words = [];
        this.runtime.targets.forEach(target => {
            target.blocks._scripts.forEach(id => {
                const BaiduAI_hear = target.blocks.getBlock(id);
                if (BaiduAI_hear.opcode === 'BaiduBrain_BaiduAI_hear') {
                    // Grab the text from the hat block's shadow.
                    const inputId = BaiduAI_hear.inputs.hear.block;
                    const inputBlock = target.blocks.getBlock(inputId);
                    // Only grab the value from text blocks. This means we'll
                    // miss some. e.g. values in variables or other reporters.
                    if (inputBlock.opcode === 'text') {
                        const word = target.blocks.getBlock(inputId).fields.TEXT.value;
                        if (txt.indexOf(word) > -1) {
                            this.runtime.startHats('BaiduBrain_BaiduAI_hear', { TEXT: word });
                            words.push(word);
                        }
                    }
                }
            });
        });
    }
    resetListening () {
        this.runtime.emitMicListening(false);
        // Note that this can be called before any Listen And Wait block did setup,
        // so check that things exist before disconnecting them.
        if (this._context) {
            this._context.suspend.bind(this._context);
        }
        // This is called on green flag to reset things that may never have existed
        // in the first place. Do a bunch of checks.
        if (this._scriptNode) {
            this._scriptNode.removeEventListener('audioprocess', this.processAudioCallback);
            this._scriptNode.disconnect();
        }
        if (this._sourceNode) {
            this._sourceNode.disconnect();
        }

    }

    vocieTimeout (args, util) {

        this._context && this._context.resume(); // 需要重新激活

        let timeout = parseInt(args.TIMEOUT, 10);
        timeout = timeout < 1 ? 1 : timeout;
        timeout = timeout > 60 ? 60 : timeout;
        this.runtime.emitMicListening(true);
        this.bufferArray = [];

        return new Promise((resolve, reject) => {
            this._sourceNode = this._context.createMediaStreamSource(this._micStream);
            this._scriptNode = this._context.createScriptProcessor(BUFSIZE, 1, 1);

            this._sourceNode.connect(this._scriptNode);
            this._scriptNode.addEventListener('audioprocess', this.processAudioCallback);
            this._scriptNode.connect(this._context.destination);
            setTimeout(this.recognize, timeout * 1000);
            this._onSpeechDone = resolve;
            this._onSpeechFail = reject;
        });
    }
    BaiduAI_hear (args) {
        // console.log("hear", args)
        return true
    };
    voiceInput (args) {
        // console.log("voiceInput", args) 
        return this.result;
    };
    ttsCharacters (args) {
        this.ttsCharactersPer = args.ttsCharacters
    };
    textToSpeech (args) {
        // console.log("textToSpeech---",args)
        const accessToken = this.baidu_access_token;
        let textToSpeech = encodeURIComponent(args.textToSpeech);
        textToSpeech = encodeURIComponent(textToSpeech);
        const resJson = {
            tex: textToSpeech,
            tok: accessToken,
            cuid: 'scratch3',
            ctp: 1,
            lan: 'zh',
            per: parseInt(this.ttsCharactersPer)
        };
        // let token = this.getAccessToken().accessToken;
        // const url = `${this.domain}/api/baiduaips/aipspeechText2audio?access_token=${token}`;
        // `https://tsn.baidu.com/text2audio`
        return new Promise((resolve, reject) => {
            fetch(`https://tsn.baidu.com/text2audio`, {
                body: formatData(resJson),
                // body: JSON.stringify({"tex":"你好"}),//formatData(resJson), // JSON.stringify(resJson),
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }).then(e => {
                if (e.status == 200) {
                    let headers_map = {};
                    for (let [key, value] of e.headers) {
                        headers_map[key] = value;
                    }
                    if (headers_map['content-type'] === 'application/json') {
                        return e.json();
                    } else {
                        // 'audio/mp3'
                        return e.arrayBuffer();
                    }
                }
            }).then(ret => {
                // console.log(ret.json)
                if (ret.err_no) {
                    let err_msg = 'error'
                    if (baidu_aip_error_map.speech_recognize_error_code[ret.err_no]) {
                        err_msg = baidu_aip_error_map.speech_recognize_error_code[ret.err_no];
                    } else {
                        err_msg = ret.err_msg;
                    }
                    throw err_msg;
                }
                
                this.runtime.audioEngine.decodeSoundPlayer({
                    data: {
                        buffer: ret // ret.arrayBuffer
                    }
                }).then(player => {
                    player.setPlaybackRate(1);
                    const effectChain = this.runtime.audioEngine.createEffectChain();
                    effectChain.set('volume', 250);
                    player.connect(effectChain);
                    player.play();
                    player.on('stop', () => {
                        resolve();
                    });
                })
            }).catch(err => {
                alert(err);
            });
        })
    };

    countString (str) {
        let sum = 0
        for (let i = 0; i < str.length; i++) {
            if ((str.charCodeAt(i) >= 0) && (str.charCodeAt(i) <= 255)) {
                sum += 1;
            } else {
                sum += 3;
            }
        }
        return sum
    }

    springFestivalCouplets (args) {

        if (new Date().getTime() - springFestivalCouplets_stamp < 5 * 1000) {
            return Promise.reject('写春联请求过于频繁，请设定好请求频率')
        }
        springFestivalCouplets_stamp = new Date().getTime()
        let token = this.getAccessToken().accessToken;
        let keyword = `${new Date().getDate()}_${args.springFestivalCouplets}`;
        if (this.countString(args.springFestivalCouplets) > 15) {
            console.log(args.springFestivalCouplets)
            alert('输入字符数量超过限制，最多5个汉字或15个字母')
            return Promise.reject('输入字符数量超过限制，最多5个汉字或15个字母')
        }
        return new Promise((resolve, reject) => {
            if (localStorage.getItem(keyword)) {
                resolve(localStorage.getItem(keyword))
            } else {
                fetch(`${this.domain}/api/baiduaips/aipCouplets?access_token=${token}`, {
                    body: JSON.stringify({
                        'text': args.springFestivalCouplets,
                        'index': 0,
                    }),
                    headers: {
                        'content-type': 'application/json'
                    },
                    method: 'POST'
                }).then(res => res.json()).then(ret => {
                    if (ret.error_code) {
                        if (baidu_aip_error_map.nlp_error_code[ret.error_code]) {
                            alert(baidu_aip_error_map.nlp_error_code[ret.error_code])
                            return reject(baidu_aip_error_map.nlp_error_code[ret.error_code]);
                        }
                        // if (/porn or politics/g.test(ret.error_msg)) {
                        //     alert('输入包含敏感词汇，请更换关键词');
                        //     return reject('输入包含敏感词汇，请更换关键词');
                        // }
                        alert(ret.error_msg);
                        return reject(ret.error_msg);
                    }
                    const { first, second, center } = ret.couplets;
                    const value = `上联：${first}\n下联：${second}\n横批：${center}`
                    localStorage.setItem(keyword, `${value}`)
                    resolve(value)
                });
            }

        });


    }
    poems (args) {
        if (new Date().getTime() - poems_stamp < 5 * 1000) {
            return Promise.reject('写诗请求过于频繁，请设定好请求频率')
        }
        poems_stamp = new Date().getTime()
        let token = this.getAccessToken().accessToken;
        if (this.countString(args.poems) > 15) {
            console.log(args.poems)
            alert('输入字符数量超过限制，最多5个汉字或15个字母')
            return Promise.reject('输入字符数量超过限制，最多5个汉字或15个字母')
        }
        return new Promise((resolve, reject) => {
            fetch(`${this.domain}/api/baiduaips/aipPoem?access_token=${token}`, {
                body: JSON.stringify({
                    'text': args.poems,
                    'index': 0,
                }),
                headers: {
                    'content-type': 'application/json'
                },
                method: 'POST'
            }).then(res => res.json()).then(ret => {

                if (ret.error_code) {
                    if (baidu_aip_error_map.nlp_error_code[ret.error_code]) {
                        alert(baidu_aip_error_map.nlp_error_code[ret.error_code]);
                        return reject(baidu_aip_error_map.nlp_error_code[ret.error_code]);
                    }
                    alert(ret.error_msg);
                    return reject(ret.error_msg);
                }

                const poem = ret.poem[0];
                console.log('poem----', poem)
                resolve(`${poem.title}\n${poem.content}`)
            });
        });
    }
    identifyCategories (args, util) {
        let token = this.getAccessToken().accessToken;
        this.recognizeResult = null;
        const regType = args.identifyCategories;
        this.renderer.draw()
        let img = this.renderer.canvas.toDataURL('image/png');
        // console.log('image --> ', image)
        img = img.replace('data:image/png;base64,', '')
        // const img = util.ioQuery('fs', 'stageCanvasData', []).replace('data:image/png;base64,', ''
        const url = `${this.domain}${recognizeMap[regType]}?access_token=${token}`;
        let resJson = {
            'image': img,
        }
        if (regType == 'ingredient') {
            resJson['top_num'] = 1;
        }
        if (regType == 'plant') {
            resJson['baike_num'] = 1;
        }
        if (regType == 'dish') {
            resJson['top_num'] = 1;
            resJson['filter_threshold'] = 0.95;
            resJson['baike_num'] = 1;
        }
        if (regType == 'animal' || regType == 'car') {
            resJson['top_num'] = 1;
            resJson['baike_num'] = 1;
        }

        return new Promise(resolve => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(resJson)
                // ='+ encodeURIComponent(image) + "&top_num=1"
            }).then(res => res.json()).then(ret => {
                // landmark
                if (ret.error_code) {
                    if (baidu_aip_error_map.image_error_code[ret.error_code]) {
                        alert(baidu_aip_error_map.image_error_code[ret.error_code]);
                        return reject(baidu_aip_error_map.image_error_code[ret.error_code]);
                    }
                    alert(ret.error_msg);
                    return reject(ret.error_msg);
                }

                if (regType == 'landmark') {
                    resolve(ret.result.landmark)
                } else if (regType == 'redwine') {
                    resolve(ret.result.wineNameCn)
                } else {
                    resolve(ret.result[0].name)
                }
                this.recognizeResult = ret.result;
                this.runtime.startHats('BaiduBrain_identityComplete', {});
            });
        });
    };
    identityComplete (args) {
        // console.log("identityComplete", args);
        return true;

    };
    identityResults (args) {
        if (this.recognizeResult && this.recognizeResult.wineNameCn) {
            return this.recognizeResult.wineNameCn;
        } else if (this.recognizeResult && this.recognizeResult.landmark) {
            return this.recognizeResult.landmark;
        } else if (this.recognizeResult && this.recognizeResult.length) {
            return this.recognizeResult[0].name;
        }
    };
    characterType (args, util) {
        let token = this.getAccessToken().accessToken;
        this.recognizeResult = null;
        // const regType = args.identifyCategories;
        this.renderer.draw()
        let img = this.renderer.canvas.toDataURL('image/png');
        img = img.replace('data:image/png;base64,', '')
        const url = `${this.domain}${wordTMap[args.textType]}?access_token=${token}`;
        let resJson = {
            'image': img,
            multi_detect: true
        }
        // console.log("characterType---args", args)

        // console.log("characterType --- blocks ", util.getBlocks())
        console.log('this -- ', this)
        // console.log("thread.peekStack --- ", util.blockId)
        let blocks = util.getBlocks()
        let blockId = util.blockId
        let thisBlock = blocks[blockId]
        let listBlock = blocks[thisBlock.inputs.textArr.block]
        // const definitionBlock = util.thread.target.blocks.getBlock(blockId);
        // console.log('characterType -- listBlock ', listBlock)
        if (listBlock.opcode != 'data_listcontents') {
            alert('输出需要数组类型')
            return Promise.reject('输出需要数组类型');
        }
        // let values = util.getBlocksFn._getBlockParams(listBlock)
        // console.log('characterType -- values ', values)

        let variable = this.runtime.getTargetForStage().variables[listBlock.fields.LIST.id] // .value;
        // RenderedTarget
        // console.log('characterType -- variable ', variable)
        // 

        return new Promise(resolve => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(resJson)
                // ='+ encodeURIComponent(image) + "&top_num=1"
            }).then(res => res.json()).then(ret => {
                console.log('characterType--result', ret)

                if (ret.error_code) {
                    if (baidu_aip_error_map.ocr_error_code[ret.error_code]) {
                        alert(baidu_aip_error_map.ocr_error_code[ret.error_code]);
                        return reject(baidu_aip_error_map.ocr_error_code[ret.error_code]);
                    }
                    alert(ret.error_msg);
                    return reject(ret.error_msg);
                }

                resolve()
                // this.characterResults = ret.words_result;
                let variableValue = ret.words_result.map(i => {
                    return i.number || i.words
                })
                variable.setValue(variableValue)
                // this.runtime.getTargetForStage().variables[listBlock.fields.LIST.id].value = variableValue
                // this.runtime.startHats('BaiduBrain_identityComplete', {});
            });
        });
    };
    characterTypeResults () {
        if (this.characterResults) {
            console.log('characterResults', this.characterResults)
            return this.characterResults
        } else {
            console.log('error-----')
        }
    }
    // ocrRecognize (args, util){
    //     const regType = args.TYPE;
    //     const list = util.ioQuery('fs', 'getBlockListPointer', [util.blockid, 'OUTPUT']);
    //     if (!list){
    //       return Promise.reject('输出需要数组类型');
    //     }

    //     const img = util.ioQuery('fs', 'stageCanvasData', []).replace('data:image/png;base64,', '');
    //     const url = `${ocrMap[regType]}?access_token=${tokens.image}`;
    //     return new Promise((resolve, reject) => {
    //       fetch(url, {
    //         method: 'POST',
    //         headers: {
    //           'Content-Type': 'application/x-www-form-urlencoded'
    //         },
    //         body: 'image='+ encodeURIComponent(img)
    //       }).then(res => res.json()).then(ret => {
    //         if (ret.words_result && ret.words_result.length > 0){
    //           const words = [];
    //           for (let r of ret.words_result){
    //             words.push(r.words);
    //           }
    //           list.value = words;
    //           resolve(words)
    //         } else if (regType === "carplate" && ret.words_result && ret.words_result.number){
    //           list.value = [ret.words_result.number];
    //           resolve(ret.words_result.number)
    //         } else {
    //           resolve('')
    //         }
    //       }).catch(err => {
    //         reject(err)
    //       });
    //     });
    //   }

    //人脸检测
    faceMarker (arg) {
        this.faceDetectedResult = false;
        let token = this.getAccessToken().accessToken;
        this.renderer.draw();
        let img = this.renderer.canvas.toDataURL('image/png');
        img = img.replace('data:image/png;base64,', '')
        const url = `${this.domain}/api/baiduaips/faceDetect?access_token=${token}`;
        let resJson = {
            'image': img,
            'image_type': 'BASE64'
        }
        return new Promise(resolve => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(resJson)

            }).then(res => res.json()).then(ret => {
                console.log("faceMarker", ret)

                if (ret.error_code) {
                    if (baidu_aip_error_map.face_error_code[ret.error_code]) {
                        alert(baidu_aip_error_map.face_error_code[ret.error_code]);
                        return reject(baidu_aip_error_map.face_error_code[ret.error_code]);
                    }
                    alert(ret.error_msg);
                    return reject(ret.error_msg);
                }

                if (ret.result && ret.result.face_list) {
                    let res = ret.result.face_list[0];
                    this.faceAgeResult = res.age;
                    this.beautyResult = res.beauty;
                    this.faceSexResult = sexType[res.gender.type];
                    this.faceShapeResult = shapeType[res.face_shape.type]
                    this.faceExpressionResult = expressionType[res.expression.type];
                }
                if (ret.error_msg == "SUCCESS") {
                    this.faceDetectedResult = true
                }
                resolve();
                this.runtime.startHats('BaiduBrain_faceDetected', {});
            });
        });
    }
    faceDetected (arg) {
        console.log("faceDetected", this.faceDetectedResult)
        return this.faceDetectedResult
    };
    faceAge () {
        if (this.faceAgeResult) {
            return this.faceAgeResult
        }
        console.log("ageageagegag--->", this.faceAgeResult)
    };
    faceGender () {
        if (this.faceSexResult) {
            return this.faceSexResult
        }
    };
    faceExpression () {
        if (this.faceExpressionResult) {
            return this.faceExpressionResult
        }
    };
    faceAppearance () {
        if (this.beautyResult) {
            return this.beautyResult
        }
    };
    faceShape () {
        if (this.faceShapeResult) {
            return this.faceShapeResult
        }
    };
    //j检测结果判断
    gender (arg) {
        // console.log("gender----->", arg)
        if (this.faceSexResult == sexType[arg.gender]) {
            return true
        } else {
            return false
        }
    };
    expression (arg) {
        if (this.faceExpressionResult == expressionType[arg.expression]) {
            return true
        } else {
            return false
        }
    };
    feature (arg) {
        if (this.faceShapeResult == shapeType[arg.feature]) {
            return true
        } else {
            return false
        }
    };
    //创建人脸组  
    faceGroupCreate (arg) {
        console.log("创建人脸组", arg)
        let token = this.getAccessToken().accessToken;
        const url = `${this.domain}/api/baiduaips/faceFacesetGroupAdd?access_token=${token}`;
        let resJson = {
            'group_id': arg.faceGroupArr,
        }
        return new Promise(resolve => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(resJson)

            }).then(res => res.json()).then(ret => {
                console.log("faceGroupCreate", ret)
                if (ret.error_code) {
                    if (baidu_aip_error_map.face_error_code[ret.error_code]) {
                        alert(baidu_aip_error_map.face_error_code[ret.error_code]);
                        return reject(baidu_aip_error_map.face_error_code[ret.error_code]);
                    }
                    alert(ret.error_msg);
                    return reject(ret.error_msg);
                }
                // if (ret.result && ret.result.face_list) {
                //     let res = ret.result.face_list[0];
                //     this.faceAgeResult = res.age;
                //     this.beautyResult = res.beauty;
                //     this.faceSexResult = sexType[res.gender.type];
                //     this.faceShapeResult = shapeType[res.face_shape.type]
                //     this.faceExpressionResult = expressionType[res.expression.type]
                // }
                resolve(ret.error_msg);
            });
        });
    };
    faceGroupAdd (arg) {
        let token = this.getAccessToken().accessToken;
        this.renderer.draw();
        let img = this.renderer.canvas.toDataURL('image/png');
        img = img.replace('data:image/png;base64,', '');
        const url = `${this.domain}/api/baiduaips/faceFacesetUserAdd?access_token=${token}`;

        let resJson = {
            'image': img,
            'image_type': 'BASE64',
            'group_id': arg.faceArr,
            'user_id': arg.faceAddName

        }
        return new Promise((resolve, reject) => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(resJson)

            }).then(res => res.json()).then(ret => {
                console.log("faceGroupAdd", ret)
                // if (ret.result && ret.result.face_list) {
                //     let res = ret.result.face_list[0];
                //     this.faceAgeResult = res.age;
                //     this.beautyResult = res.beauty;
                //     this.faceSexResult = sexType[res.gender.type];
                //     this.faceShapeResult = shapeType[res.face_shape.type]
                //     this.faceExpressionResult = expressionType[res.expression.type]
                // }
                // error_code: 222210
                // error_msg: "the number of user's faces is beyond the limit"

                if (ret.error_code) {
                    if (baidu_aip_error_map.face_error_code[ret.error_code]) {
                        alert(baidu_aip_error_map.face_error_code[ret.error_code]);
                        return reject(baidu_aip_error_map.face_error_code[ret.error_code]);
                    }
                    alert(ret.error_msg);
                    return reject(ret.error_msg);
                }

                if (ret.error_code == 222210) {
                    if (/beyond the limit/g.test(ret.error_msg)) {
                        alert('该用户名注册人脸数量超过最大限额，请更换用户名')
                        return reject('该用户名注册人脸数量超过最大限额，请更换用户名');
                    }
                }
                resolve(ret.error_msg);
            });
        });
    };
    faceGroupSearch (arg) {
        let token = this.getAccessToken().accessToken;
        this.renderer.draw();
        let img = this.renderer.canvas.toDataURL('image/png');
        img = img.replace('data:image/png;base64,', '');
        const url = `${this.domain}/api/baiduaips/faceSearch?access_token=${token}`;

        let resJson = {
            'image': img,
            'image_type': 'BASE64',
            'group_id_list': arg.faceGroupSearchArr,
        }
        return new Promise(resolve => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(resJson)

            }).then(res => res.json()).then(ret => {

                if (ret.error_code) {
                    if (baidu_aip_error_map.face_error_code[ret.error_code]) {
                        alert(baidu_aip_error_map.face_error_code[ret.error_code]);
                        return reject(baidu_aip_error_map.face_error_code[ret.error_code]);
                    }
                    alert(ret.error_msg);
                    return reject(ret.error_msg);
                }

                if (ret.result && ret.result.user_list) {
                    let res = ret.result.user_list[0];
                    this.searchResultNames = res.user_id;
                    this.searchScore = res.score
                }
                resolve(ret.error_msg);

                const words = [];
                this.runtime.targets.forEach(target => {
                    target.blocks._scripts.forEach(id => {
                        const BaiduAI_hear = target.blocks.getBlock(id);
                        if (BaiduAI_hear.opcode === 'BaiduBrain_BaiduAI_face_search') {
                            // Grab the text from the hat block's shadow.
                            const inputId = BaiduAI_hear.inputs.searchName.block;
                            const inputBlock = target.blocks.getBlock(inputId);
                            // Only grab the value from text blocks. This means we'll
                            // miss some. e.g. values in variables or other reporters.
                            if (inputBlock.opcode === 'text') {
                                const word = target.blocks.getBlock(inputId).fields.TEXT.value;
                                if (this.searchResultNames.indexOf(word) > -1) {
                                    this.runtime.startHats('BaiduBrain_BaiduAI_face_search', { TEXT: word });
                                    words.push(word);
                                }
                            }
                        }
                    });
                });
                this.runtime.startHats('BaiduBrain_searchDone', {});
            });
        });

    };
    faceGroupSearchLevel (arg) {
        let token = this.getAccessToken().accessToken;
        this.renderer.draw();
        let img = this.renderer.canvas.toDataURL('image/png');
        img = img.replace('data:image/png;base64,', '');
        const url = `${this.domain}/api/baiduaips/faceSearch?access_token=${token}`;

        let resJson = {
            'image': img,
            'image_type': 'BASE64',
            'group_id_list': arg.faceSearchArr,
        }
        return new Promise(resolve => {
            fetch(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                body: JSON.stringify(resJson)

            }).then(res => res.json()).then(ret => {
                if (ret.error_code) {
                    if (baidu_aip_error_map.face_error_code[ret.error_code]) {
                        alert(baidu_aip_error_map.face_error_code[ret.error_code]);
                        return reject(baidu_aip_error_map.face_error_code[ret.error_code]);
                    }
                    alert(ret.error_msg);
                    return reject(ret.error_msg);
                }
                if (ret.result && ret.result.user_list) {
                    let res = ret.result.user_list[0];
                    if (res.score > arg.reliability) {
                        this.searchResultNames = res.user_id;
                        this.searchScore = res.score
                    }
                }
                resolve(ret.error_msg);

                const words = [];
                this.runtime.targets.forEach(target => {
                    target.blocks._scripts.forEach(id => {
                        const BaiduAI_hear = target.blocks.getBlock(id);
                        if (BaiduAI_hear.opcode === 'BaiduBrain_BaiduAI_face_search') {
                            // Grab the text from the hat block's shadow.
                            const inputId = BaiduAI_hear.inputs.searchName.block;
                            const inputBlock = target.blocks.getBlock(inputId);
                            // Only grab the value from text blocks. This means we'll
                            // miss some. e.g. values in variables or other reporters.
                            if (inputBlock.opcode === 'text') {
                                const word = target.blocks.getBlock(inputId).fields.TEXT.value;
                                if (this.searchResultNames.indexOf(word) > -1) {
                                    this.runtime.startHats('BaiduBrain_BaiduAI_face_search', { TEXT: word });
                                    words.push(word);
                                }
                            }
                        }
                    });
                });
                // resolve();
                this.runtime.startHats('BaiduBrain_searchDone', {});
            });
        });
    };

    BaiduAI_face_search (arg) {
        if (this.searchResultNames == arg.searchName) {
            return true
        }
    };
    searchDone () {
        return true;
    };

    searchResultName () {
        if (this.searchResultNames) {
            return this.searchResultNames
        } else {
            return ''
        }
    };
    searchReliability () {
        if (this.searchScore) {
            return this.searchScore
        }
    };
    //百度翻译
    /**
    * Get the viewer's language code.
    * @return {string} the language code.
    */
    getViewerLanguageCode () {
        const locale = formatMessage.setup().locale;
        const viewerLanguages = [locale].concat(navigator.languages);
        const languageKeys = Object.keys(languageNames.menuMap);
        // Return the first entry in viewerLanguages that matches
        // one of the available language keys.
        const languageCode = viewerLanguages.reduce((acc, lang) => {
            if (acc) {
                return acc;
            }
            if (languageKeys.indexOf(lang.toLowerCase()) > -1) {
                return lang;
            }
            return acc;
        }, '') || 'en';

        return languageCode.toLowerCase();
    };
    /**
    * Computes a list of language code and name pairs for the given language.
    * @param {string} code The language code to get the list of language pairs
    * @return {Array.<object.<string, string>>} An array of languge name and
    *   language code pairs.
    * @private
    */
    _getSupportedLanguages (code) {

        return [
            // {text: '自动检测', value: 'auto'},
            { text: '中文', value: 'zh' },
            { text: '英语', value: 'en' },
            { text: '粤语', value: 'yue' },
            { text: '文言文', value: 'wyw' },
            { text: '日语', value: 'jp' },
            { text: '韩语', value: 'kor' },
            { text: '法语', value: 'fra' },
            { text: '西班牙语', value: 'spa' },
            { text: '泰语', value: 'th' },
            { text: '阿拉伯语', value: 'ara' },
            { text: '俄语', value: 'ru' },
            { text: '葡萄牙语', value: 'pt' },
            { text: '德语', value: 'de' },
            { text: '意大利语', value: 'it' },
            { text: '希腊语', value: 'el' },
            { text: '荷兰语', value: 'nl' },
            { text: '波兰语', value: 'pl' },
            { text: '保加利亚语', value: 'bul' },
            { text: '爱沙尼亚语', value: 'est' },
            { text: '丹麦语', value: 'dan' },
            { text: '芬兰语', value: 'fin' },
            { text: '捷克语', value: 'cs' },
            { text: '罗马尼亚语', value: 'rom' },
            { text: '斯洛文尼亚语', value: 'slo' },
            { text: '瑞典语', value: 'swe' },
            { text: '匈牙利语', value: 'hu' },
            { text: '繁体中文', value: 'cht' },
            { text: '越南语', value: 'vie' },
        ]
        // return languageNames.menuMap[code].map(entry => {
        //     const obj = {text: entry.name, value: entry.code};
        //     return obj;
        // });
    };

    /**
   * Get the human readable language value for the reporter block.
   * @return {string} the language name of the project viewer.
   */
    getViewerLanguage () {
        this._viewerLanguageCode = this.getViewerLanguageCode();
        const names = languageNames.menuMap[this._viewerLanguageCode];
        let langNameObj = names.find(obj => obj.code === this._viewerLanguageCode);

        // If we don't have a name entry yet, try looking it up via the Google langauge
        // code instead of Scratch's (e.g. for es-419 we look up es to get espanol)
        if (!langNameObj && languageNames.scratchToGoogleMap[this._viewerLanguageCode]) {
            const lookupCode = languageNames.scratchToGoogleMap[this._viewerLanguageCode];
            langNameObj = names.find(obj => obj.code === lookupCode);
        }

        let langName = this._viewerLanguageCode;
        if (langNameObj) {
            langName = langNameObj.name;
        }
        return langName;
    }

    /**
     * Get the viewer's language code.
     * @return {string} the language code.
     */
    getViewerLanguageCode () {
        const locale = formatMessage.setup().locale;
        const viewerLanguages = [locale].concat(navigator.languages);
        const languageKeys = Object.keys(languageNames.menuMap);
        // Return the first entry in viewerLanguages that matches
        // one of the available language keys.
        const languageCode = viewerLanguages.reduce((acc, lang) => {
            if (acc) {
                return acc;
            }
            if (languageKeys.indexOf(lang.toLowerCase()) > -1) {
                return lang;
            }
            return acc;
        }, '') || 'en';

        return languageCode.toLowerCase();
    }


    /**
   * Translates the text in the translate block to the language specified in the menu.
   * @param {object} args - the block arguments.
   * @return {Promise} - a promise that resolves after the response from the translate server.
   */
    getTranslate_mit (args) {
        // Don't remake the request if we already have the value.
        if (this._lastTextTranslated === args.WORDS &&
            this._lastLangTranslated === args.LANGUAGE) {
            return this._translateResult;
        }

        const lang = this.getLanguageCodeFromArg(args.LANGUAGE);

        let urlBase = `${serverURL}translate?language=`;
        urlBase += lang;
        urlBase += '&text=';
        urlBase += encodeURIComponent(args.WORDS);

        const tempThis = this;
        const translatePromise = new Promise(resolve => {
            nets({
                url: urlBase,
                timeout: serverTimeoutMs
            }, (err, res, body) => {
                if (err) {
                    log.warn(`error fetching translate result! ${res}`);
                    resolve('');
                    return '';
                }
                const translated = JSON.parse(body).result;
                tempThis._translateResult = translated;
                // Cache what we just translated so we don't keep making the
                // same call over and over.
                tempThis._lastTextTranslated = args.WORDS;
                tempThis._lastLangTranslated = args.LANGUAGE;
                resolve(translated);
                return translated;
            });

        });
        translatePromise.then(translatedText => translatedText);
        return translatePromise;
    };
    getTranslate (args) {
        // Don't remake the request if we already have the value.
        let token = this.getAccessToken().accessToken;

        if (this._lastTextTranslated === args.WORDS && this._lastLangTranslated === args.LANGUAGE) {
            return this._translateResult;
        }

        // http://api.fanyi.baidu.com/api/trans/vip/translate
        // https://fanyi-api.baidu.com/api/trans/vip/translate
        const lang = this.getLanguageCodeFromArg(args.LANGUAGE);
        // let salt = Date.now()
        // let urlBase = `https://fanyi-api.baidu.com/api/trans/vip/translate?`
        // urlBase += `q=${encodeURIComponent(args.WORDS)}`
        // urlBase += `&from=auto`
        // urlBase += `&to=${lang}`
        // urlBase += `&appid=20200617000498135`
        // urlBase += `&salt=${salt}`
        // // md5('Message to hash');
        // // var hash = md5.create();
        // // hash.update('Message to hash');
        // // hash.hex();
        // let sign = md5(`20200617000498135${args.WORDS}${salt}gidlWZEVfi1FBWmRsG7x`)
        // urlBase += `&sign=${sign}`

        const tempThis = this;
        const translatePromise = new Promise(resolve => {
            nets({
                // url: urlBase,
                url: `${this.domain}/api/baiduaips/fanyi?access_token=${token}`,
                timeout: serverTimeoutMs,
                method: 'post',
                json: true,
                body: {
                    q: args.WORDS,
                    from: 'auto',
                    to: lang
                }
            }, (err, res, body) => {
                if (err) {
                    log.warn(`error fetching translate result! ${res}`);
                    resolve('');
                    return '';
                }
                if (body.error_msg) {
                    log.warn(body.error_msg);
                    resolve('');
                    return '';
                }
                let translated = body.trans_result;
                translated = translated.map(i => i.dst)
                translated = translated.join('')
                tempThis._translateResult = translated;
                // Cache what we just translated so we don't keep making the
                // same call over and over.
                tempThis._lastTextTranslated = args.WORDS;
                tempThis._lastLangTranslated = args.LANGUAGE;
                resolve(translated);
                return translated;
            });

        });
        translatePromise.then(translatedText => translatedText);
        return translatePromise;
    };
    /**
    * Get a language code from a block argument. The arg can be a language code
    * or a language name, written in any language.
    * @param  {object} arg A block argument.
    * @return {string} A language code.
    */
    getLanguageCodeFromArg (arg) {
        return arg;
        // const languageArg = Cast.toString(arg).toLowerCase();
        // // Check if the arg matches a language code in the menu.
        // if (languageNames.menuMap.hasOwnProperty(languageArg)) {
        //     return languageArg;
        // }
        // // Check for a dropped-in language name, and convert to a language code.
        // if (languageNames.nameMap.hasOwnProperty(languageArg)) {
        //     return languageNames.nameMap[languageArg];
        // }

        // // There are some languages we launched in the language menu that Scratch did not
        // // end up launching in. In order to keep projects that may have had that menu item
        // // working, check for those language codes and let them through.
        // // Examples: 'ab', 'hi'.
        // if (languageNames.previouslySupported.indexOf(languageArg) !== -1) {
        //     return languageArg;
        // }
        // // Default to English.
        // return 'en';
    }

    // 将 xx 替换为 xx
    replace_to (arg) {
        arg.replace_origin
        arg.replace_from
        arg.replace_to

        let result = arg.replace_origin

        let regex = new RegExp(arg.replace_from, 'g')
        result = arg.replace_origin.replace(regex, arg.replace_to)

        return result
    };
}

module.exports = BaiduBrainBlocks;
